<template>
    <el-drawer :title="!id ? '新增事件转化率报表' : '编辑事件转化率报表'" :visible.sync="drawerShow" :wrapperClosable="false"
        :destroy-on-close="true" size="600px" @close="close">
        <div class="drawer-content" v-loading="dataLoading">
            <el-form :model="formData" :rules="rules" ref="formData" label-position="top" size="medium">

                <el-form-item prop="name" label="报表名称:">
                    <el-input v-model="formData.name" placeholder="请输入报表名称" maxlength="40"></el-input>
                </el-form-item>
                <el-form-item v-for="(item, index) in formData.childList" :key="index">
                    <span slot="label">
                        步骤{{ index + 1 }}:
                        <el-button v-if="index > 1" type="text"
                            @click="formData.childList.splice(index, 1)">删除</el-button>
                    </span>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item :prop="`childList[${index}].eventId`"
                                :rules="[{ required: true, message: '请选择已有事件' }]">
                                <el-select v-model="item.eventId" placeholder="请选择已有事件" filterable>
                                    <el-option v-for="(v) in eventList" :key="v.key" :label="`${v.value}:${v.key}`"
                                        :value="v.key"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :prop="`childList[${index}].name`"
                                :rules="[{ required: true, message: '请输入步骤名称' }]">
                                <el-input v-model="item.name" placeholder="请输入步骤名称" maxlength="40"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-button v-if="formData.childList.length < 10" type="text" icon="el-icon-plus"
                    @click="addGroup()">添加步骤</el-button>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">确认</el-button>
        </div>
    </el-drawer>
</template>
<script>
const defaultData = {
    name: '',
    childList: [{
        eventId: '',
        id: '',
        name: '',
        parentId: '',
    }, {
        eventId: '',
        id: '',
        name: '',
        parentId: '',
    }, {
        eventId: '',
        id: '',
        name: '',
        parentId: '',
    }]
}
export default {

    data() {
        return {
            id: '',
            drawerShow: false,
            dataLoading: false,
            btnLoading: false,
            formData: {
                ...defaultData
            },
            rules: {
                name: [{ required: true, message: "请输入报表名称" }],
            },
            eventList: []
        }
    },
    created() {
        this.getEventList();
    },
    methods: {
        getEventList() {
            this.$request({
                url: '/eventManage/eventSelect',
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.eventList = result;
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
        },
        close() {
            this.drawerShow = false;
        },
        show(_id) {
            this.drawerShow = true;
            this.$nextTick(() => {
                this.$refs.formData.clearValidate();
                this.formData = {
                    name: '',
                    childList: [{
                        eventId: '',
                        id: '',
                        name: '',
                        parentId: '',
                    }, {
                        eventId: '',
                        id: '',
                        name: '',
                        parentId: '',
                    }, {
                        eventId: '',
                        id: '',
                        name: '',
                        parentId: '',
                    }]
                }
                if (_id) {
                    this.id = _id;
                    this.getDataDetail();
                }
            })


        },
        getDataDetail() {
            this.dataLoading = true;
            this.$request({
                url: '/event/conversionRate/detail',
                params: { id: this.id },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.formData = result;
                    } else {
                        this.$message.error(msg || "请求失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("请求失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        addGroup() {
            this.formData.childList.push({
                eventId: '',
                id: '',
                name: '',
                parentId: '',
            })
        },
        submitForm() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;

                    this.formData.childList.map((item, index) => {
                        item.sort = index;
                    })
                    this.$request({
                        url: '/event/conversionRate/save',
                        data: { ...this.formData },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('onUpdate');
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped></style>